module.exports = __webpack_public_path__ + "img/broad_rounded.96830ed.svg";